import React from "react";
import { Redirect, Route } from "react-router-dom";

export default function PublicRoute({ component: Component, ...rest }) {
  const isLogin = JSON.parse(localStorage.getItem("isLogin"));

  return (
    <>
      {isLogin === "1" ? (
        <Redirect to="/mappr" />
      ) : (
        <Route
          {...rest}
          component={(props) => {
            return <Component {...props} />;
          }}
        />
      )}
    </>
  );
}
